import { createActionHandler, createReducer } from '@pressreader/appstore';
import { logOutDone, userChangeDone } from '@pressreader/authentication-core';
import { BundleOrderDto } from '@pressreader/commerce-api';
import { ISubscriptionProduct, ITrialEligibility } from '@pressreader/commerce-types';

import { loadSubscriptionDone, loadTrialEligibilityDoneEvent, resetCheckoutAttempt, setCheckoutIdempotencyKey } from './actions';

interface State {
    currentSubscription: ISubscriptionProduct | null;
    activeBundles: BundleOrderDto[] | null;
    trialEligibility: ITrialEligibility | null;
    // Memory-only: the commerce feature is not persisted, so the key never survives a
    // page reload or a new session.
    idempotencyKey: string | null;
}

const initialState: State = {
    currentSubscription: null,
    activeBundles: [],
    trialEligibility: null,
    idempotencyKey: null,
};

const reducer = createReducer<State>(
    initialState,

    createActionHandler(loadSubscriptionDone, (state, { payload: { currentSubscription, activeBundles } }) => ({
        ...state,
        currentSubscription,
        activeBundles,
    })),

    createActionHandler(logOutDone, state => ({
        ...state,

        currentSubscription: null,
        idempotencyKey: null,
    })),

    createActionHandler(userChangeDone, state => ({
        ...state,
        trialEligibility: null,
        idempotencyKey: null,
    })),

    createActionHandler(loadTrialEligibilityDoneEvent, (state, { payload: { trialEligibility } }) => ({
        ...state,
        trialEligibility,
    })),

    createActionHandler(setCheckoutIdempotencyKey, (state, { payload: { key } }) => ({
        ...state,
        idempotencyKey: key,
    })),

    createActionHandler(resetCheckoutAttempt, state => ({
        ...state,
        idempotencyKey: null,
    })),
);

export { reducer, State };
